import { kBlockedFieldTag } from "../constants";

const SENTINEL = kBlockedFieldTag;
const OBSERVED_ATTRS = ["title", "placeholder", "aria-label"];

/**
 * Dev-mode MutationObserver that warns whenever the raw "__blocked__" sentinel
 * leaks into rendered DOM text or common display attributes.
 *
 * Gated on localhost -- zero production cost.
 * Call once from app init (index.tsx). Idempotent: repeat calls are no-ops.
 */
let started = false;

function checkNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    if (node.textContent && node.textContent.includes(SENTINEL)) {
      console.warn("[CRLS LEAK] __blocked__ sentinel in text node:", node.parentElement);
    }
    return;
  }

  if (node.nodeType === Node.ELEMENT_NODE) {
    for (const attr of OBSERVED_ATTRS) {
      const val = node.getAttribute?.(attr);
      if (val && val.includes(SENTINEL)) {
        console.warn(`[CRLS LEAK] __blocked__ sentinel in ${attr} attribute:`, node);
      }
    }
  }
}

function handleMutations(mutations) {
  for (const mutation of mutations) {
    if (mutation.type === "childList") {
      for (const node of mutation.addedNodes) {
        checkNode(node);
        if (node.nodeType === Node.ELEMENT_NODE) {
          const walker = document.createTreeWalker(
            node,
            window.NodeFilter.SHOW_TEXT | window.NodeFilter.SHOW_ELEMENT
          );
          while (walker.nextNode()) {
            checkNode(walker.currentNode);
          }
        }
      }
    } else if (mutation.type === "characterData") {
      checkNode(mutation.target);
    } else if (mutation.type === "attributes") {
      checkNode(mutation.target);
    }
  }
}

export function startBlockedFieldObserver() {
  if (started) return;
  if (typeof window === "undefined") return;
  if (window.location.hostname !== "localhost") return;

  started = true;

  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: OBSERVED_ATTRS
  });
}
